import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { IsUUID } from 'class-validator';
import { PageDetails } from '../core';
export class ListLocationsQuery {
    constructor(courtSystemId, isArchived, page, includeEmptyLocations, filterInaccessible) {
        this.courtSystemId = courtSystemId;
        this.isArchived = isArchived;
        this.page = page;
        this.includeEmptyLocations = includeEmptyLocations;
        this.filterInaccessible = filterInaccessible;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ListLocationsQuery.prototype, "courtSystemId", void 0);
__decorate([
    Serialize(() => Boolean),
    __metadata("design:type", Object)
], ListLocationsQuery.prototype, "isArchived", void 0);
__decorate([
    Serialize(() => Boolean),
    __metadata("design:type", Object)
], ListLocationsQuery.prototype, "filterInaccessible", void 0);
__decorate([
    Serialize(() => Boolean),
    __metadata("design:type", Object)
], ListLocationsQuery.prototype, "includeEmptyLocations", void 0);
__decorate([
    Type(() => PageDetails),
    __metadata("design:type", PageDetails)
], ListLocationsQuery.prototype, "page", void 0);
